<template>
  <div class="root">
    <select
      v-bind="$attrs"
      :ref="`${name}-select`"
      v-on="$listeners"
      class="b-input"
      :name="name"
      :value="value"
      :style="cssStyle"
      @input="$emit('update', $event.target.value)"
      @change="onChange"
    >
      <option disabled v-if="placeholder" value="">{{ placeholder }}</option>
      <option :value="option.value" :key="option.value" v-for="option in options">{{ option.label }}</option>
    </select>
    <span class="b-error-message" v-if="error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    error: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    cssStyle: {
      type: String,
    },
  },
  model: {
    prop: "value",
    event: "update",
  },
  methods: {
    onChange(event) {
      // Supports .lazy
      // Can add validation here
      this.$emit("change", event.target.value);
    },
  },
};
</script>

<style scoped>
.root {
  position: relative;
  width: -webkit-fill-available;
}
.b-input {
  padding: 2px 2px;
  border: solid 1px #cdcdcd;
  border-radius: 4px;
  background: white;
  width: -webkit-fill-available;
}

.b-input[disabled] {
  background-color: #f4f4f4;
}

.b-input:hover {
  border-width: 1px;
  border-color: #b6b6b6;
}
.b-input:focus-visible {
  outline: none;
  border: solid 1px #4e63ff;
}

.b-error-message {
  position: absolute;
  right: 5px;
  top: 3px;
  margin: 0;
  font-style: oblique;
  color: #ff0505;
  margin-right: 16px;
  font-size: 1.5rem;
}
</style>
